/* eslint-disable */
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
/** @typedef {{}} Abandonsession1Inputs */
/** @typedef {{}} Abandonsessioncancel2Inputs */
/** @typedef {{}} Abandonsessionconfirm2Inputs */
/** @typedef {{}} Abandonsessionconfirmaction3Inputs */
/** @typedef {{}} Accountaccessdenied2Inputs */
/** @typedef {{}} Agentbusy1Inputs */
/** @typedef {{ count: NonNullable<unknown> }} Agenthostbusymany3Inputs */
/** @typedef {{}} Agenthostbusyone3Inputs */
/** @typedef {{}} Agentmodel1Inputs */
/** @typedef {{}} Agentmodelhint2Inputs */
/** @typedef {{}} Agentname1Inputs */
/** @typedef {{}} Agentstatus1Inputs */
/** @typedef {{}} Agentthinking1Inputs */
/** @typedef {{}} Agentworking1Inputs */
/** @typedef {{}} Apicallfailed2Inputs */
/** @typedef {{}} Apiunreachable1Inputs */
/** @typedef {{}} Appssectionlabel2Inputs */
/** @typedef {{}} Attachfiles1Inputs */
/** @typedef {{}} Automationscanceledit2Inputs */
/** @typedef {{}} Automationscreate1Inputs */
/** @typedef {{}} Automationscreateheading2Inputs */
/** @typedef {{}} Automationsdelete1Inputs */
/** @typedef {{}} Automationsdisable1Inputs */
/** @typedef {{}} Automationsdisabled1Inputs */
/** @typedef {{}} Automationsedit1Inputs */
/** @typedef {{}} Automationsempty1Inputs */
/** @typedef {{}} Automationsenable1Inputs */
/** @typedef {{}} Automationsenabled1Inputs */
/** @typedef {{}} Automationsfieldcron2Inputs */
/** @typedef {{}} Automationsfieldparentsession3Inputs */
/** @typedef {{}} Automationsfieldprompt2Inputs */
/** @typedef {{}} Automationsfieldproposemr3Inputs */
/** @typedef {{}} Automationsfieldtitle2Inputs */
/** @typedef {{}} Automationsgroupsheading2Inputs */
/** @typedef {{ status: NonNullable<unknown>, summary: NonNullable<unknown> }} Automationslatestrun2Inputs */
/** @typedef {{}} Automationslead1Inputs */
/** @typedef {{}} Automationsnav1Inputs */
/** @typedef {{}} Automationsnoparentsessions3Inputs */
/** @typedef {{}} Automationsopensession2Inputs */
/** @typedef {{}} Automationsreadonly2Inputs */
/** @typedef {{}} Automationsrunnow2Inputs */
/** @typedef {{}} Automationssave1Inputs */
/** @typedef {{}} Automationstitle1Inputs */
/** @typedef {{}} Brandlogoalt2Inputs */
/** @typedef {{}} Browserlivepreview2Inputs */
/** @typedef {{}} Browserlivepreviewalt3Inputs */
/** @typedef {{}} Browserlivepreviewhide3Inputs */
/** @typedef {{}} Browserlivepreviewshow3Inputs */
/** @typedef {{}} Capturepreview1Inputs */
/** @typedef {{}} Capturepreviewfailed2Inputs */
/** @typedef {{}} Capturepreviewhint2Inputs */
/** @typedef {{}} Capturepreviewunavailable2Inputs */
/** @typedef {{}} Captureselectionhint2Inputs */
/** @typedef {{}} Captureselectionunavailable2Inputs */
/** @typedef {{}} Changetarget1Inputs */
/** @typedef {{}} Chatregion1Inputs */
/** @typedef {{}} Chattitle1Inputs */
/** @typedef {{}} Closeconversationhistory2Inputs */
/** @typedef {{}} Collapsechat1Inputs */
/** @typedef {{}} Collapseconversationrail2Inputs */
/** @typedef {{}} Continuelastappaction3Inputs */
/** @typedef {{}} Continuelastappbadge3Inputs */
/** @typedef {{}} Continuelastappdescription3Inputs */
/** @typedef {{}} Continuelastappsectionlabel4Inputs */
/** @typedef {{}} Conversationhistory1Inputs */
/** @typedef {{}} Conversationhistoryempty2Inputs */
/** @typedef {{}} Conversationrail1Inputs */
/** @typedef {{}} Conversationrailmineempty3Inputs */
/** @typedef {{}} Conversationrailshowall3Inputs */
/** @typedef {{}} Conversationrailshowmine3Inputs */
/** @typedef {{}} Copylink1Inputs */
/** @typedef {{}} Defaultindependentappaction3Inputs */
/** @typedef {{}} Defaultindependentappbadge3Inputs */
/** @typedef {{}} Deletescratchappaction3Inputs */
/** @typedef {{}} Deletescratchappcancel3Inputs */
/** @typedef {{}} Deletescratchappconfirmaction4Inputs */
/** @typedef {{ label: NonNullable<unknown> }} Deletescratchappconfirmlead4Inputs */
/** @typedef {{}} Deletescratchappconfirmtitle4Inputs */
/** @typedef {{}} Deletescratchappworking3Inputs */
/** @typedef {{}} Deploycancelaction2Inputs */
/** @typedef {{}} Deployconfirmaction2Inputs */
/** @typedef {{}} Deploymodedialogtitle3Inputs */
/** @typedef {{}} Deploymodenewapp3Inputs */
/** @typedef {{}} Deploymodereplaceparent3Inputs */
/** @typedef {{}} Deploymodethisapp3Inputs */
/** @typedef {{}} Deploynewsluglabel3Inputs */
/** @typedef {{}} Deploynewslugplaceholder3Inputs */
/** @typedef {{ url: NonNullable<unknown> }} Deploypublicurlhint3Inputs */
/** @typedef {{}} Deploysessionaction2Inputs */
/** @typedef {{ hostname: NonNullable<unknown> }} Deploysessionsucceeded2Inputs */
/** @typedef {{}} Deploysessionworking2Inputs */
/** @typedef {{}} Deploysluginvalidhint3Inputs */
/** @typedef {{}} Deployslugreservedhint3Inputs */
/** @typedef {{}} Deployslugtakenhint3Inputs */
/** @typedef {{}} Deployedappeditaction3Inputs */
/** @typedef {{}} Deployedappopenaction3Inputs */
/** @typedef {{}} Deployedapprevertaction3Inputs */
/** @typedef {{}} Deployedapprevertcancel3Inputs */
/** @typedef {{}} Deployedapprevertconfirm3Inputs */
/** @typedef {{}} Deployedapprevertdialogtitle4Inputs */
/** @typedef {{}} Deployedapprevertempty3Inputs */
/** @typedef {{}} Deployedapprevertworking3Inputs */
/** @typedef {{}} Deployedappstopaction3Inputs */
/** @typedef {{}} Deployedappsempty2Inputs */
/** @typedef {{}} Deployedappssectionlabel3Inputs */
/** @typedef {{}} Dictatemessage1Inputs */
/** @typedef {{}} Dictationunsupported1Inputs */
/** @typedef {{ fileName: NonNullable<unknown> }} Downloadattachment1Inputs */
/** @typedef {{}} Expandchat1Inputs */
/** @typedef {{}} Expandconversationrail2Inputs */
/** @typedef {{}} Favoritebadge1Inputs */
/** @typedef {{}} Favoriteopenaction2Inputs */
/** @typedef {{}} Favoritesempty1Inputs */
/** @typedef {{}} Favoritessectionlabel2Inputs */
/** @typedef {{}} Homelead1Inputs */
/** @typedef {{}} Identityproviderunavailable2Inputs */
/** @typedef {{}} Independentappssectionempty3Inputs */
/** @typedef {{}} Independentappssectionlabel3Inputs */
/** @typedef {{}} Inspecthint1Inputs */
/** @typedef {{ messageKey: NonNullable<unknown>, filePart: NonNullable<unknown>, textPart: NonNullable<unknown> }} Inspectselectionwithkey3Inputs */
/** @typedef {{}} Inspectselectionsheader2Inputs */
/** @typedef {{}} Linkcopied1Inputs */
/** @typedef {{}} Lintfailed1Inputs */
/** @typedef {{}} Loadingsession1Inputs */
/** @typedef {{}} LoginInputs */
/** @typedef {{}} Logininstructions1Inputs */
/** @typedef {{}} Logintitle1Inputs */
/** @typedef {{}} LogoutInputs */
/** @typedef {{}} Maximizechat1Inputs */
/** @typedef {{}} Mergerequestopened2Inputs */
/** @typedef {{}} Mergerequestupdated2Inputs */
/** @typedef {{}} Messageplaceholder1Inputs */
/** @typedef {{}} Missingrootelement2Inputs */
/** @typedef {{}} Newconversation1Inputs */
/** @typedef {{}} Newscratchappaction3Inputs */
/** @typedef {{}} Newscratchappcancel3Inputs */
/** @typedef {{}} Newscratchappcreating3Inputs */
/** @typedef {{}} Newscratchappdescription3Inputs */
/** @typedef {{}} Newscratchapplabel3Inputs */
/** @typedef {{}} Newscratchappnamelabel4Inputs */
/** @typedef {{}} Newscratchappnameplaceholder4Inputs */
/** @typedef {{ slug: NonNullable<unknown> }} Newscratchappslughint4Inputs */
/** @typedef {{}} Newscratchappsluginvalid4Inputs */
/** @typedef {{}} Openmergerequest2Inputs */
/** @typedef {{}} Openspecarchivemergerequestopened4Inputs */
/** @typedef {{}} Pagetitle1Inputs */
/** @typedef {{}} Pinfavorite1Inputs */
/** @typedef {{}} Previewdevicedesktop2Inputs */
/** @typedef {{}} Previewdevicemobile2Inputs */
/** @typedef {{}} Previewdeviceswitch2Inputs */
/** @typedef {{}} Previewdevicetablet2Inputs */
/** @typedef {{}} Previewoff1Inputs */
/** @typedef {{}} Previewpathapply2Inputs */
/** @typedef {{}} Previewpathback2Inputs */
/** @typedef {{}} Previewpathforward2Inputs */
/** @typedef {{}} Previewpathinvalid2Inputs */
/** @typedef {{}} Previewpathlabel2Inputs */
/** @typedef {{}} Previewpathofforigin3Inputs */
/** @typedef {{}} Previewpathpresetcatalogue3Inputs */
/** @typedef {{}} Previewpathpresetdiaporama3Inputs */
/** @typedef {{}} Previewpathpresethome3Inputs */
/** @typedef {{}} Previewpathpresets2Inputs */
/** @typedef {{}} Previewregion1Inputs */
/** @typedef {{}} Previewrestoring1Inputs */
/** @typedef {{}} Promptactivityclose2Inputs */
/** @typedef {{}} Promptactivityempty2Inputs */
/** @typedef {{}} Promptactivitylead2Inputs */
/** @typedef {{}} Promptactivityloadfailed3Inputs */
/** @typedef {{}} Promptactivitytitle2Inputs */
/** @typedef {{}} Promptactivityuntitled2Inputs */
/** @typedef {{}} Quickstartaction2Inputs */
/** @typedef {{}} Quickstartlabel2Inputs */
/** @typedef {{}} Quickstartnostartertarget4Inputs */
/** @typedef {{}} Quickstartplaceholder2Inputs */
/** @typedef {{}} Quickstartworking2Inputs */
/** @typedef {{}} Redeploysessionaction2Inputs */
/** @typedef {{ fileName: NonNullable<unknown> }} Removeattachment1Inputs */
/** @typedef {{ label: NonNullable<unknown> }} Removeselection1Inputs */
/** @typedef {{}} Renameconversation1Inputs */
/** @typedef {{}} Requestrequired1Inputs */
/** @typedef {{}} Resizechat1Inputs */
/** @typedef {{}} Restorechat1Inputs */
/** @typedef {{}} Saveconversationtitle2Inputs */
/** @typedef {{}} Securespace1Inputs */
/** @typedef {{}} Selectcomponent1Inputs */
/** @typedef {{}} Sendmessage1Inputs */
/** @typedef {{}} Servicetemporarilyunavailable2Inputs */
/** @typedef {{}} Sessionaccessdenied2Inputs */
/** @typedef {{}} Sessionaccessdeniedlead3Inputs */
/** @typedef {{}} Sessionloading1Inputs */
/** @typedef {{}} Sessionmakeopen2Inputs */
/** @typedef {{}} Sessionmakeprivate2Inputs */
/** @typedef {{}} Sessionmissing1Inputs */
/** @typedef {{}} Sessionpublishmenu2Inputs */
/** @typedef {{}} Sessionshareadd2Inputs */
/** @typedef {{}} Sessionshareemailplaceholder3Inputs */
/** @typedef {{}} Sessionsharedwithyou3Inputs */
/** @typedef {{}} Sessionsharing1Inputs */
/** @typedef {{}} Sessionunshare1Inputs */
/** @typedef {{ email: NonNullable<unknown> }} Sessionunshareemail2Inputs */
/** @typedef {{}} Sessionvisibilityopen2Inputs */
/** @typedef {{}} Sessionvisibilityprivate2Inputs */
/** @typedef {{}} SettingsInputs */
/** @typedef {{}} Settingsclose1Inputs */
/** @typedef {{}} Settingscreateappheading3Inputs */
/** @typedef {{}} Settingscreateapplead3Inputs */
/** @typedef {{}} Settingscreateappsubtitle3Inputs */
/** @typedef {{}} Settingscreateapptoggle3Inputs */
/** @typedef {{}} Settingsdeleteappheading3Inputs */
/** @typedef {{}} Settingsdeleteapplead3Inputs */
/** @typedef {{}} Settingsdeleteappsubtitle3Inputs */
/** @typedef {{}} Settingsdeleteapptoggle3Inputs */
/** @typedef {{}} Settingseyebrow1Inputs */
/** @typedef {{}} Settingspreviewpathbarheading4Inputs */
/** @typedef {{}} Settingspreviewpathbarlead4Inputs */
/** @typedef {{}} Settingspreviewpathbarsubtitle4Inputs */
/** @typedef {{}} Settingspreviewpathbartoggle4Inputs */
/** @typedef {{}} Settingspromptactivityheading3Inputs */
/** @typedef {{}} Settingspromptactivitylead3Inputs */
/** @typedef {{}} Settingspromptactivitysubtitle3Inputs */
/** @typedef {{}} Settingspromptactivitytoggle3Inputs */
/** @typedef {{}} Settingstitle1Inputs */
/** @typedef {{}} Sourceconnectaction2Inputs */
/** @typedef {{}} Sourceconnectconnecting2Inputs */
/** @typedef {{}} Sourceconnectopenviewer3Inputs */
/** @typedef {{}} Sourceconnectskip2Inputs */
/** @typedef {{}} Sourceconnecttitle2Inputs */
/** @typedef {{}} Startpreview1Inputs */
/** @typedef {{}} Startsectionlabel2Inputs */
/** @typedef {{}} Startsectionlead2Inputs */
/** @typedef {{}} Startsectiontitle2Inputs */
/** @typedef {{}} Startingrequest1Inputs */
/** @typedef {{}} Stopdictation1Inputs */
/** @typedef {{}} Stopselectingcomponent2Inputs */
/** @typedef {{}} Stopturn1Inputs */
/** @typedef {{}} Studioname1Inputs */
/** @typedef {{}} Studiowelcomeeyebrow2Inputs */
/** @typedef {{ name: NonNullable<unknown> }} Studiowelcometitleattack3Inputs */
/** @typedef {{ name: NonNullable<unknown> }} Studiowelcometitleembellish3Inputs */
/** @typedef {{ name: NonNullable<unknown> }} Studiowelcometitlehello3Inputs */
/** @typedef {{ name: NonNullable<unknown> }} Studiowelcometitleidea3Inputs */
/** @typedef {{ name: NonNullable<unknown> }} Studiowelcometitleimprove3Inputs */
/** @typedef {{}} Syncsessionbase2Inputs */
/** @typedef {{}} Targetopenaction2Inputs */
/** @typedef {{}} Targetpickerempty2Inputs */
/** @typedef {{}} Targetpickerlead2Inputs */
/** @typedef {{ label: NonNullable<unknown> }} Targetpreviewlabel2Inputs */
/** @typedef {{}} Targetpreviewunavailable2Inputs */
/** @typedef {{}} Targetresumeaction2Inputs */
/** @typedef {{}} Targetselectlabel2Inputs */
/** @typedef {{}} Targettilemenulabel3Inputs */
/** @typedef {{}} Targetwipbadge2Inputs */
/** @typedef {{}} Teachbrowserdiscard2Inputs */
/** @typedef {{}} Teachbrowseropenviewer3Inputs */
/** @typedef {{}} Teachbrowserpromote2Inputs */
/** @typedef {{}} Teachbrowserready2Inputs */
/** @typedef {{}} Teachbrowserrecording2Inputs */
/** @typedef {{}} Teachbrowsershowpath3Inputs */
/** @typedef {{}} Teachbrowserstop2Inputs */
/** @typedef {{}} Teachbrowsersummary2Inputs */
/** @typedef {{}} Technicaldetails1Inputs */
/** @typedef {{}} Unknowncreator1Inputs */
/** @typedef {{}} Unpinfavorite1Inputs */
/** @typedef {{}} Untitledconversation1Inputs */
/** @typedef {{}} Updatemergerequest2Inputs */
/** @typedef {{}} Websitesectionempty2Inputs */
/** @typedef {{}} Websitesectionlabel2Inputs */
/** @typedef {{}} Youname1Inputs */


export const abandonsession1 = /** @type {(inputs: Abandonsession1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

export const abandonsessioncancel2 = /** @type {(inputs: Abandonsessioncancel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

export const abandonsessionconfirm2 = /** @type {(inputs: Abandonsessionconfirm2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this conversation? The preview, Git branch, and all related history will be permanently removed.`)
};

export const abandonsessionconfirmaction3 = /** @type {(inputs: Abandonsessionconfirmaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

export const accountaccessdenied2 = /** @type {(inputs: Accountaccessdenied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account has no access to Studio.`)
};

export const agentbusy1 = /** @type {(inputs: Agentbusy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A turn is already in progress on this conversation.`)
};

export const agenthostbusymany3 = /** @type {(inputs: Agenthostbusymany3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The agent is busy on ${i?.count} other conversations. Your request may wait.`)
};

export const agenthostbusyone3 = /** @type {(inputs: Agenthostbusyone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The agent is busy on 1 other conversation. Your request may wait.`)
};

export const agentmodel1 = /** @type {(inputs: Agentmodel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model`)
};

export const agentmodelhint2 = /** @type {(inputs: Agentmodelhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model used for the next messages`)
};

export const agentname1 = /** @type {(inputs: Agentname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistant`)
};

export const agentstatus1 = /** @type {(inputs: Agentstatus1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Step`)
};

export const agentthinking1 = /** @type {(inputs: Agentthinking1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thinking`)
};

export const agentworking1 = /** @type {(inputs: Agentworking1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working…`)
};

export const apicallfailed2 = /** @type {(inputs: Apicallfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Try again in a moment.`)
};

export const apiunreachable1 = /** @type {(inputs: Apiunreachable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio is temporarily unavailable. Try again in a moment.`)
};

export const appssectionlabel2 = /** @type {(inputs: Appssectionlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apps`)
};

export const attachfiles1 = /** @type {(inputs: Attachfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attach a file`)
};

export const automationscanceledit2 = /** @type {(inputs: Automationscanceledit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

export const automationscreate1 = /** @type {(inputs: Automationscreate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

export const automationscreateheading2 = /** @type {(inputs: Automationscreateheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New automation`)
};

export const automationsdelete1 = /** @type {(inputs: Automationsdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

export const automationsdisable1 = /** @type {(inputs: Automationsdisable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disable`)
};

export const automationsdisabled1 = /** @type {(inputs: Automationsdisabled1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`disabled`)
};

export const automationsedit1 = /** @type {(inputs: Automationsedit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

export const automationsempty1 = /** @type {(inputs: Automationsempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No automations yet.`)
};

export const automationsenable1 = /** @type {(inputs: Automationsenable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable`)
};

export const automationsenabled1 = /** @type {(inputs: Automationsenabled1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`enabled`)
};

export const automationsfieldcron2 = /** @type {(inputs: Automationsfieldcron2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule (cron)`)
};

export const automationsfieldparentsession3 = /** @type {(inputs: Automationsfieldparentsession3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parent conversation`)
};

export const automationsfieldprompt2 = /** @type {(inputs: Automationsfieldprompt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructions`)
};

export const automationsfieldproposemr3 = /** @type {(inputs: Automationsfieldproposemr3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propose a merge request after the run`)
};

export const automationsfieldtitle2 = /** @type {(inputs: Automationsfieldtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

export const automationsgroupsheading2 = /** @type {(inputs: Automationsgroupsheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By conversation`)
};

export const automationslatestrun2 = /** @type {(inputs: Automationslatestrun2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Latest run (${i?.status}): ${i?.summary}`)
};

export const automationslead1 = /** @type {(inputs: Automationslead1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheduled recipes linked to a Studio conversation. Each run inherits the parent session's target.`)
};

export const automationsnav1 = /** @type {(inputs: Automationsnav1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automations`)
};

export const automationsnoparentsessions3 = /** @type {(inputs: Automationsnoparentsessions3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No conversation available`)
};

export const automationsopensession2 = /** @type {(inputs: Automationsopensession2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open conversation`)
};

export const automationsreadonly2 = /** @type {(inputs: Automationsreadonly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read-only — you cannot manage automations.`)
};

export const automationsrunnow2 = /** @type {(inputs: Automationsrunnow2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run now`)
};

export const automationssave1 = /** @type {(inputs: Automationssave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

export const automationstitle1 = /** @type {(inputs: Automationstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automations`)
};

export const brandlogoalt2 = /** @type {(inputs: Brandlogoalt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stimcar`)
};

export const browserlivepreview2 = /** @type {(inputs: Browserlivepreview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser`)
};

export const browserlivepreviewalt3 = /** @type {(inputs: Browserlivepreviewalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live preview of the agent-driven browser`)
};

export const browserlivepreviewhide3 = /** @type {(inputs: Browserlivepreviewhide3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide`)
};

export const browserlivepreviewshow3 = /** @type {(inputs: Browserlivepreviewshow3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show browser`)
};

export const capturepreview1 = /** @type {(inputs: Capturepreview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capture preview`)
};

export const capturepreviewfailed2 = /** @type {(inputs: Capturepreviewfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not capture the preview.`)
};

export const capturepreviewhint2 = /** @type {(inputs: Capturepreviewhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Captures the whole preview (no screen share).`)
};

export const capturepreviewunavailable2 = /** @type {(inputs: Capturepreviewunavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview capture is not available right now.`)
};

export const captureselectionhint2 = /** @type {(inputs: Captureselectionhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Captures the element selected with the crosshair (no screen share).`)
};

export const captureselectionunavailable2 = /** @type {(inputs: Captureselectionunavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reselect the element with the crosshair, then try capture again.`)
};

export const changetarget1 = /** @type {(inputs: Changetarget1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch application`)
};

export const chatregion1 = /** @type {(inputs: Chatregion1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation`)
};

export const chattitle1 = /** @type {(inputs: Chattitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation`)
};

export const closeconversationhistory2 = /** @type {(inputs: Closeconversationhistory2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close history`)
};

export const collapsechat1 = /** @type {(inputs: Collapsechat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fold conversation aside`)
};

export const collapseconversationrail2 = /** @type {(inputs: Collapseconversationrail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse conversation list`)
};

export const continuelastappaction3 = /** @type {(inputs: Continuelastappaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

export const continuelastappbadge3 = /** @type {(inputs: Continuelastappbadge3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last app`)
};

export const continuelastappdescription3 = /** @type {(inputs: Continuelastappdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume your last independent application.`)
};

export const continuelastappsectionlabel4 = /** @type {(inputs: Continuelastappsectionlabel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

export const conversationhistory1 = /** @type {(inputs: Conversationhistory1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation history`)
};

export const conversationhistoryempty2 = /** @type {(inputs: Conversationhistoryempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No conversations yet.`)
};

export const conversationrail1 = /** @type {(inputs: Conversationrail1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations`)
};

export const conversationrailmineempty3 = /** @type {(inputs: Conversationrailmineempty3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have no conversations yet.`)
};

export const conversationrailshowall3 = /** @type {(inputs: Conversationrailshowall3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show all conversations`)
};

export const conversationrailshowmine3 = /** @type {(inputs: Conversationrailshowmine3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show only mine`)
};

export const copylink1 = /** @type {(inputs: Copylink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy link`)
};

export const defaultindependentappaction3 = /** @type {(inputs: Defaultindependentappaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start here`)
};

export const defaultindependentappbadge3 = /** @type {(inputs: Defaultindependentappbadge3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start here`)
};

export const deletescratchappaction3 = /** @type {(inputs: Deletescratchappaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

export const deletescratchappcancel3 = /** @type {(inputs: Deletescratchappcancel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

export const deletescratchappconfirmaction4 = /** @type {(inputs: Deletescratchappconfirmaction4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete app`)
};

export const deletescratchappconfirmlead4 = /** @type {(inputs: Deletescratchappconfirmlead4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`“${i?.label}” and its conversations will be removed from the atelier. Deployed apps and GitLab projects are not deleted here.`)
};

export const deletescratchappconfirmtitle4 = /** @type {(inputs: Deletescratchappconfirmtitle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this independent app?`)
};

export const deletescratchappworking3 = /** @type {(inputs: Deletescratchappworking3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting…`)
};

export const deploycancelaction2 = /** @type {(inputs: Deploycancelaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

export const deployconfirmaction2 = /** @type {(inputs: Deployconfirmaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm deploy`)
};

export const deploymodedialogtitle3 = /** @type {(inputs: Deploymodedialogtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do you want to deploy?`)
};

export const deploymodenewapp3 = /** @type {(inputs: Deploymodenewapp3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deploy under a new identifier`)
};

export const deploymodereplaceparent3 = /** @type {(inputs: Deploymodereplaceparent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update the already deployed app`)
};

export const deploymodethisapp3 = /** @type {(inputs: Deploymodethisapp3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deploy this application`)
};

export const deploynewsluglabel3 = /** @type {(inputs: Deploynewsluglabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App name (URL)`)
};

export const deploynewslugplaceholder3 = /** @type {(inputs: Deploynewslugplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`my-new-app`)
};

export const deploypublicurlhint3 = /** @type {(inputs: Deploypublicurlhint3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Public URL: ${i?.url}`)
};

export const deploysessionaction2 = /** @type {(inputs: Deploysessionaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deploy`)
};

export const deploysessionsucceeded2 = /** @type {(inputs: Deploysessionsucceeded2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Application deployed: ${i?.hostname}`)
};

export const deploysessionworking2 = /** @type {(inputs: Deploysessionworking2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deploying…`)
};

export const deploysluginvalidhint3 = /** @type {(inputs: Deploysluginvalidhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid identifier (lowercase letters, digits, hyphens).`)
};

export const deployslugreservedhint3 = /** @type {(inputs: Deployslugreservedhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserved identifier (mktp, web, scratch, studio, p…).`)
};

export const deployslugtakenhint3 = /** @type {(inputs: Deployslugtakenhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This identifier is already used by a deployed app.`)
};

export const deployedappeditaction3 = /** @type {(inputs: Deployedappeditaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

export const deployedappopenaction3 = /** @type {(inputs: Deployedappopenaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

export const deployedapprevertaction3 = /** @type {(inputs: Deployedapprevertaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revert to…`)
};

export const deployedapprevertcancel3 = /** @type {(inputs: Deployedapprevertcancel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

export const deployedapprevertconfirm3 = /** @type {(inputs: Deployedapprevertconfirm3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore this version`)
};

export const deployedapprevertdialogtitle4 = /** @type {(inputs: Deployedapprevertdialogtitle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revert a deployed version`)
};

export const deployedapprevertempty3 = /** @type {(inputs: Deployedapprevertempty3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No deployment history available.`)
};

export const deployedapprevertworking3 = /** @type {(inputs: Deployedapprevertworking3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restoring…`)
};

export const deployedappstopaction3 = /** @type {(inputs: Deployedappstopaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop`)
};

export const deployedappsempty2 = /** @type {(inputs: Deployedappsempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No deployed applications yet.`)
};

export const deployedappssectionlabel3 = /** @type {(inputs: Deployedappssectionlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deployed apps`)
};

export const dictatemessage1 = /** @type {(inputs: Dictatemessage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dictate message`)
};

export const dictationunsupported1 = /** @type {(inputs: Dictationunsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dictation is not available in this browser.`)
};

export const downloadattachment1 = /** @type {(inputs: Downloadattachment1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Download ${i?.fileName}`)
};

export const expandchat1 = /** @type {(inputs: Expandchat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open conversation`)
};

export const expandconversationrail2 = /** @type {(inputs: Expandconversationrail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show conversation list`)
};

export const favoritebadge1 = /** @type {(inputs: Favoritebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favorite`)
};

export const favoriteopenaction2 = /** @type {(inputs: Favoriteopenaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

export const favoritesempty1 = /** @type {(inputs: Favoritesempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No favorite conversations yet.`)
};

export const favoritessectionlabel2 = /** @type {(inputs: Favoritessectionlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favorites`)
};

export const homelead1 = /** @type {(inputs: Homelead1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe what you want to change. Each send opens a dedicated conversation, visible to the whole studio team.`)
};

export const identityproviderunavailable2 = /** @type {(inputs: Identityproviderunavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The sign-in service is temporarily unavailable. Please try again later.`)
};

export const independentappssectionempty3 = /** @type {(inputs: Independentappssectionempty3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No independent applications yet.`)
};

export const independentappssectionlabel3 = /** @type {(inputs: Independentappssectionlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Independent apps`)
};

export const inspecthint1 = /** @type {(inputs: Inspecthint1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click an element in the preview.`)
};

export const inspectselectionwithkey3 = /** @type {(inputs: Inspectselectionwithkey3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- Selected UI: messageKey=${i?.messageKey}${i?.filePart}${i?.textPart}`)
};

export const inspectselectionsheader2 = /** @type {(inputs: Inspectselectionsheader2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected UI components:`)
};

export const linkcopied1 = /** @type {(inputs: Linkcopied1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copied`)
};

export const lintfailed1 = /** @type {(inputs: Lintfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not send the proposal: automatic checks failed. Ask the assistant to fix them, then try again.`)
};

export const loadingsession1 = /** @type {(inputs: Loadingsession1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening your workspace…`)
};

export const login = /** @type {(inputs: LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

export const logininstructions1 = /** @type {(inputs: Logininstructions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with your Stimcar account to access Studio.`)
};

export const logintitle1 = /** @type {(inputs: Logintitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

export const logout = /** @type {(inputs: LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out`)
};

export const maximizechat1 = /** @type {(inputs: Maximizechat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expand conversation`)
};

export const mergerequestopened2 = /** @type {(inputs: Mergerequestopened2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposal sent for review`)
};

export const mergerequestupdated2 = /** @type {(inputs: Mergerequestupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposal updated`)
};

export const messageplaceholder1 = /** @type {(inputs: Messageplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe what you want…`)
};

export const missingrootelement2 = /** @type {(inputs: Missingrootelement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Element not found`)
};

export const newconversation1 = /** @type {(inputs: Newconversation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New conversation`)
};

export const newscratchappaction3 = /** @type {(inputs: Newscratchappaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

export const newscratchappcancel3 = /** @type {(inputs: Newscratchappcancel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

export const newscratchappcreating3 = /** @type {(inputs: Newscratchappcreating3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating the application…`)
};

export const newscratchappdescription3 = /** @type {(inputs: Newscratchappdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a shared application, then work on it in a session.`)
};

export const newscratchapplabel3 = /** @type {(inputs: Newscratchapplabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New app`)
};

export const newscratchappnamelabel4 = /** @type {(inputs: Newscratchappnamelabel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application name`)
};

export const newscratchappnameplaceholder4 = /** @type {(inputs: Newscratchappnameplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Late kanbans`)
};

export const newscratchappslughint4 = /** @type {(inputs: Newscratchappslughint4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Identifier: ${i?.slug}`)
};

export const newscratchappsluginvalid4 = /** @type {(inputs: Newscratchappsluginvalid4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a name that yields a valid identifier (letters, numbers, hyphens).`)
};

export const openmergerequest2 = /** @type {(inputs: Openmergerequest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propose changes`)
};

export const openspecarchivemergerequestopened4 = /** @type {(inputs: Openspecarchivemergerequestopened4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenSpec sync/archive proposal`)
};

export const pagetitle1 = /** @type {(inputs: Pagetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

export const pinfavorite1 = /** @type {(inputs: Pinfavorite1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to favorites`)
};

export const previewdevicedesktop2 = /** @type {(inputs: Previewdevicedesktop2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop`)
};

export const previewdevicemobile2 = /** @type {(inputs: Previewdevicemobile2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile`)
};

export const previewdeviceswitch2 = /** @type {(inputs: Previewdeviceswitch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview display size`)
};

export const previewdevicetablet2 = /** @type {(inputs: Previewdevicetablet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tablet`)
};

export const previewoff1 = /** @type {(inputs: Previewoff1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview for this conversation is not available right now.`)
};

export const previewpathapply2 = /** @type {(inputs: Previewpathapply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go`)
};

export const previewpathback2 = /** @type {(inputs: Previewpathback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back`)
};

export const previewpathforward2 = /** @type {(inputs: Previewpathforward2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forward`)
};

export const previewpathinvalid2 = /** @type {(inputs: Previewpathinvalid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error: invalid path.`)
};

export const previewpathlabel2 = /** @type {(inputs: Previewpathlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview path`)
};

export const previewpathofforigin3 = /** @type {(inputs: Previewpathofforigin3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error: that address is not on the preview origin.`)
};

export const previewpathpresetcatalogue3 = /** @type {(inputs: Previewpathpresetcatalogue3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalogue`)
};

export const previewpathpresetdiaporama3 = /** @type {(inputs: Previewpathpresetdiaporama3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slideshow`)
};

export const previewpathpresethome3 = /** @type {(inputs: Previewpathpresethome3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

export const previewpathpresets2 = /** @type {(inputs: Previewpathpresets2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick paths`)
};

export const previewregion1 = /** @type {(inputs: Previewregion1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview`)
};

export const previewrestoring1 = /** @type {(inputs: Previewrestoring1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing preview…`)
};

export const promptactivityclose2 = /** @type {(inputs: Promptactivityclose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close the log`)
};

export const promptactivityempty2 = /** @type {(inputs: Promptactivityempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No recent prompts.`)
};

export const promptactivitylead2 = /** @type {(inputs: Promptactivitylead2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest agent turns started on this studio.`)
};

export const promptactivityloadfailed3 = /** @type {(inputs: Promptactivityloadfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load the activity log.`)
};

export const promptactivitytitle2 = /** @type {(inputs: Promptactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent prompts`)
};

export const promptactivityuntitled2 = /** @type {(inputs: Promptactivityuntitled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(untitled)`)
};

export const quickstartaction2 = /** @type {(inputs: Quickstartaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

export const quickstartlabel2 = /** @type {(inputs: Quickstartlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your request`)
};

export const quickstartnostartertarget4 = /** @type {(inputs: Quickstartnostartertarget4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The starter application is not available yet. Try again shortly or create a new app.`)
};

export const quickstartplaceholder2 = /** @type {(inputs: Quickstartplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask anything, or describe what you want to build…`)
};

export const quickstartworking2 = /** @type {(inputs: Quickstartworking2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating the conversation…`)
};

export const redeploysessionaction2 = /** @type {(inputs: Redeploysessionaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update deployment`)
};

export const removeattachment1 = /** @type {(inputs: Removeattachment1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.fileName}`)
};

export const removeselection1 = /** @type {(inputs: Removeselection1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.label}`)
};

export const renameconversation1 = /** @type {(inputs: Renameconversation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename conversation`)
};

export const requestrequired1 = /** @type {(inputs: Requestrequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe what you want before continuing.`)
};

export const resizechat1 = /** @type {(inputs: Resizechat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resize conversation`)
};

export const restorechat1 = /** @type {(inputs: Restorechat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse conversation`)
};

export const saveconversationtitle2 = /** @type {(inputs: Saveconversationtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save title`)
};

export const securespace1 = /** @type {(inputs: Securespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secure space`)
};

export const selectcomponent1 = /** @type {(inputs: Selectcomponent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select an element`)
};

export const sendmessage1 = /** @type {(inputs: Sendmessage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

export const servicetemporarilyunavailable2 = /** @type {(inputs: Servicetemporarilyunavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The service is temporarily unavailable.`)
};

export const sessionaccessdenied2 = /** @type {(inputs: Sessionaccessdenied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not have access to this conversation.`)
};

export const sessionaccessdeniedlead3 = /** @type {(inputs: Sessionaccessdeniedlead3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask the creator to share it or make it open.`)
};

export const sessionloading1 = /** @type {(inputs: Sessionloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading conversation…`)
};

export const sessionmakeopen2 = /** @type {(inputs: Sessionmakeopen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make open`)
};

export const sessionmakeprivate2 = /** @type {(inputs: Sessionmakeprivate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make private`)
};

export const sessionmissing1 = /** @type {(inputs: Sessionmissing1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation not found.`)
};
export { sessionpublishmenu2 } from "./fr.js"

export const sessionshareadd2 = /** @type {(inputs: Sessionshareadd2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite`)
};

export const sessionshareemailplaceholder3 = /** @type {(inputs: Sessionshareemailplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`email to invite`)
};

export const sessionsharedwithyou3 = /** @type {(inputs: Sessionsharedwithyou3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This conversation was shared with you.`)
};

export const sessionsharing1 = /** @type {(inputs: Sessionsharing1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation sharing`)
};

export const sessionunshare1 = /** @type {(inputs: Sessionunshare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

export const sessionunshareemail2 = /** @type {(inputs: Sessionunshareemail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.email}`)
};

export const sessionvisibilityopen2 = /** @type {(inputs: Sessionvisibilityopen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

export const sessionvisibilityprivate2 = /** @type {(inputs: Sessionvisibilityprivate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private`)
};

export const settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

export const settingsclose1 = /** @type {(inputs: Settingsclose1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

export const settingscreateappheading3 = /** @type {(inputs: Settingscreateappheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application creation`)
};

export const settingscreateapplead3 = /** @type {(inputs: Settingscreateapplead3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When enabled, the menu to create an independent application appears on the applications screen (if your account allows it).`)
};

export const settingscreateappsubtitle3 = /** @type {(inputs: Settingscreateappsubtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimental menu on the applications screen`)
};

export const settingscreateapptoggle3 = /** @type {(inputs: Settingscreateapptoggle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show “New app”`)
};

export const settingsdeleteappheading3 = /** @type {(inputs: Settingsdeleteappheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application deletion`)
};

export const settingsdeleteapplead3 = /** @type {(inputs: Settingsdeleteapplead3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When enabled, a Delete action appears on Independent apps tiles (if your account allows creating apps). Deployed apps must be stopped first. The default starter app cannot be deleted.`)
};

export const settingsdeleteappsubtitle3 = /** @type {(inputs: Settingsdeleteappsubtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destructive actions on independent apps`)
};

export const settingsdeleteapptoggle3 = /** @type {(inputs: Settingsdeleteapptoggle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show “Delete” on independent apps`)
};

export const settingseyebrow1 = /** @type {(inputs: Settingseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

export const settingspreviewpathbarheading4 = /** @type {(inputs: Settingspreviewpathbarheading4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview navigation`)
};

export const settingspreviewpathbarlead4 = /** @type {(inputs: Settingspreviewpathbarlead4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shows the address bar and shortcuts (catalogue, slideshow…) at the top of the preview.`)
};

export const settingspreviewpathbarsubtitle4 = /** @type {(inputs: Settingspreviewpathbarsubtitle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address bar and shortcuts (catalogue, slideshow…)`)
};

export const settingspreviewpathbartoggle4 = /** @type {(inputs: Settingspreviewpathbartoggle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show the preview navigation bar`)
};

export const settingspromptactivityheading3 = /** @type {(inputs: Settingspromptactivityheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt activity log`)
};

export const settingspromptactivitylead3 = /** @type {(inputs: Settingspromptactivitylead3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opens a window listing recent prompts on this studio (email, time, conversation). Useful before a restart or update.`)
};

export const settingspromptactivitysubtitle3 = /** @type {(inputs: Settingspromptactivitysubtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who launched a prompt, and when`)
};

export const settingspromptactivitytoggle3 = /** @type {(inputs: Settingspromptactivitytoggle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show the prompt activity log`)
};

export const settingstitle1 = /** @type {(inputs: Settingstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

export const sourceconnectaction2 = /** @type {(inputs: Sourceconnectaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect`)
};

export const sourceconnectconnecting2 = /** @type {(inputs: Sourceconnectconnecting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect open`)
};

export const sourceconnectopenviewer3 = /** @type {(inputs: Sourceconnectopenviewer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open browser`)
};

export const sourceconnectskip2 = /** @type {(inputs: Sourceconnectskip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip`)
};

export const sourceconnecttitle2 = /** @type {(inputs: Sourceconnecttitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser sources`)
};

export const startpreview1 = /** @type {(inputs: Startpreview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show preview`)
};

export const startsectionlabel2 = /** @type {(inputs: Startsectionlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

export const startsectionlead2 = /** @type {(inputs: Startsectionlead2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe what you want. We open a session on the starter application.`)
};

export const startsectiontitle2 = /** @type {(inputs: Startsectiontitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How can I help you?`)
};

export const startingrequest1 = /** @type {(inputs: Startingrequest1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating the conversation…`)
};

export const stopdictation1 = /** @type {(inputs: Stopdictation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop dictation`)
};

export const stopselectingcomponent2 = /** @type {(inputs: Stopselectingcomponent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop selecting`)
};

export const stopturn1 = /** @type {(inputs: Stopturn1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop turn`)
};

export const studioname1 = /** @type {(inputs: Studioname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

export const studiowelcomeeyebrow2 = /** @type {(inputs: Studiowelcomeeyebrow2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

export const studiowelcometitleattack3 = /** @type {(inputs: Studiowelcometitleattack3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`What should we tackle, ${i?.name}?`)
};

export const studiowelcometitleembellish3 = /** @type {(inputs: Studiowelcometitleembellish3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Which app are we polishing, ${i?.name}?`)
};

export const studiowelcometitlehello3 = /** @type {(inputs: Studiowelcometitlehello3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hi ${i?.name}, what are we working on today?`)
};

export const studiowelcometitleidea3 = /** @type {(inputs: Studiowelcometitleidea3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}, an idea to bring to life?`)
};

export const studiowelcometitleimprove3 = /** @type {(inputs: Studiowelcometitleimprove3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`What would you like to improve, ${i?.name}?`)
};
export { syncsessionbase2 } from "./fr.js"

export const targetopenaction2 = /** @type {(inputs: Targetopenaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

export const targetpickerempty2 = /** @type {(inputs: Targetpickerempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No applications registered yet.`)
};

export const targetpickerlead2 = /** @type {(inputs: Targetpickerlead2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe an idea to start, or pick an application from the menu.`)
};

export const targetpreviewlabel2 = /** @type {(inputs: Targetpreviewlabel2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preview of ${i?.label}`)
};

export const targetpreviewunavailable2 = /** @type {(inputs: Targetpreviewunavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview unavailable`)
};

export const targetresumeaction2 = /** @type {(inputs: Targetresumeaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

export const targetselectlabel2 = /** @type {(inputs: Targetselectlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application to edit`)
};

export const targettilemenulabel3 = /** @type {(inputs: Targettilemenulabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

export const targetwipbadge2 = /** @type {(inputs: Targetwipbadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In progress`)
};

export const teachbrowserdiscard2 = /** @type {(inputs: Teachbrowserdiscard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard draft`)
};

export const teachbrowseropenviewer3 = /** @type {(inputs: Teachbrowseropenviewer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open browser viewer`)
};

export const teachbrowserpromote2 = /** @type {(inputs: Teachbrowserpromote2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promote taught skill`)
};

export const teachbrowserready2 = /** @type {(inputs: Teachbrowserready2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft skill ready`)
};

export const teachbrowserrecording2 = /** @type {(inputs: Teachbrowserrecording2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recording — demonstrate the flow in the viewer`)
};

export const teachbrowsershowpath3 = /** @type {(inputs: Teachbrowsershowpath3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show the path`)
};

export const teachbrowserstop2 = /** @type {(inputs: Teachbrowserstop2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop teaching`)
};

export const teachbrowsersummary2 = /** @type {(inputs: Teachbrowsersummary2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teach summary`)
};

export const technicaldetails1 = /** @type {(inputs: Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technical details`)
};

export const unknowncreator1 = /** @type {(inputs: Unknowncreator1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown creator`)
};

export const unpinfavorite1 = /** @type {(inputs: Unpinfavorite1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove from favorites`)
};

export const untitledconversation1 = /** @type {(inputs: Untitledconversation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New conversation`)
};

export const updatemergerequest2 = /** @type {(inputs: Updatemergerequest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update proposal`)
};

export const websitesectionempty2 = /** @type {(inputs: Websitesectionempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No website targets registered yet.`)
};

export const websitesectionlabel2 = /** @type {(inputs: Websitesectionlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website`)
};

export const youname1 = /** @type {(inputs: Youname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You`)
};